export default {
  setApp (state, app) {
    state.app = app
  },

  setTitle (state, title) {
    state.title = title
  },

  setLocale (state, locale) {
    state.locale = locale
  },
}
